function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-miterlimit:10;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M205.75,42.45c0,4.63-2.05,6.77-6.8,6.77a7,7,0,0,1-1.88-.23V45.37a8,8,0,0,0,1.36.15c2.08,0,3.07-.72,3.07-4V28.41h4.25Z",
  transform: "translate(-14.11 -14.11)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M224,41.67c0,4.77-2.92,7.81-7.52,7.81s-7.53-3-7.53-7.81,2.93-7.82,7.53-7.82S224,36.89,224,41.67Zm-10.79,0c0,2.86,1.27,4.69,3.27,4.69s3.27-1.83,3.27-4.69S218.51,37,216.52,37,213.25,38.8,213.25,41.67Z",
  transform: "translate(-14.11 -14.11)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M231.13,36.08a4.9,4.9,0,0,1,4.17-2.14c3.67,0,6,3,6,7.73s-2.4,7.73-6.11,7.73A4.85,4.85,0,0,1,231,47.08h0V49H227V28.41h4v7.67Zm-.26,5.59c0,2.92,1.24,4.63,3.07,4.63s3.18-1.82,3.18-4.63S235.88,37,233.94,37,230.87,38.75,230.87,41.67Z",
  transform: "translate(-14.11 -14.11)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M261.4,35.56h-4.28a4,4,0,0,0-4.26-3.85c-3.12,0-5,2.66-5,7s1.88,7,4.95,7a4.1,4.1,0,0,0,4.34-3.94h4.37c-.4,4.9-3.68,7.7-8.71,7.7-5.79,0-9.35-4.08-9.35-10.76S247,28,252.86,28C258,28,261.2,31.08,261.4,35.56Z",
  transform: "translate(-14.11 -14.11)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M268.72,35.94a5,5,0,0,1,4-2c3.3,0,5.42,2,5.42,6v9h-4.06V40.4c0-2.23-1-3.25-2.57-3.25s-2.9,1.31-2.9,4V49h-4.05V28.41h4.05v7.53Z",
  transform: "translate(-14.11 -14.11)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M291.24,44.56h4.14c-.58,2.7-3.13,4.92-7,4.92-4.63,0-7.32-3.24-7.32-7.93,0-4.34,2.69-7.7,7.29-7.7a6.79,6.79,0,0,1,6.81,4.9,12.44,12.44,0,0,1,.46,3.76H285c.12,3,1.6,4.11,3.33,4.11A2.67,2.67,0,0,0,291.24,44.56ZM285.1,40h6.43c-.26-2.23-1.6-3.24-3.22-3.24S285.42,37.73,285.1,40Z",
  transform: "translate(-14.11 -14.11)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M312.25,39.79H308A2.72,2.72,0,0,0,305.27,37c-2,0-3.15,1.79-3.15,4.69s1.18,4.69,3.15,4.69c1.56,0,2.61-1.19,2.72-3.1h4.26a6.54,6.54,0,0,1-6.95,6.22c-4.49,0-7.41-3.06-7.41-7.81s2.92-7.82,7.41-7.82C309.27,33.85,311.93,36.34,312.25,39.79Z",
  transform: "translate(-14.11 -14.11)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M324.14,49l-4.92-6.89h-.06V49h-4.05V28.41h4.05V40.25h.06L324,34.32h4.57L323,41.09l6.2,7.93Z",
  transform: "translate(-14.11 -14.11)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M331.23,49V28.41h4.25V49Z",
  transform: "translate(-14.11 -14.11)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M351.89,49l-4-8.36c-1.3-2.75-2.61-5.65-3.76-8.51h-.06c.14,3,.23,6,.23,8.94V49h-4.08V28.41h6l4,8.37c1.3,2.75,2.61,5.64,3.76,8.51h.06c-.14-3-.23-6-.23-8.95V28.41h4.08V49Z",
  transform: "translate(-14.11 -14.11)"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M14.11,23.52H17.6V45.91H14.11Zm3.62,0h1.18l2.18,22.39H19.9Zm5.66,0h1.18L22.4,45.91H21.21Zm1.31,0h3.52V45.91H24.7Z",
  transform: "translate(-14.11 -14.11)"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M41.44,23.52V40.63a2.11,2.11,0,0,0,4.22,0V23.52h3.52V40.76a5.64,5.64,0,0,1-11.26,0V23.52Z",
  transform: "translate(-14.11 -14.11)"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M63.55,23.52V45.91H60V23.52Zm1.34,0,3.33,22.39H67L63.68,23.52Zm7,0V45.91H68.35V23.52Z",
  transform: "translate(-14.11 -14.11)"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M86.56,44.67V24.76h-3V23.52h9.57v1.24h-3V44.67h3v1.24H83.55V44.67Z",
  transform: "translate(-14.11 -14.11)"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M18.14,55.52V77.91H16.41V55.52Zm7.49,0h1.95l-7.29,11.1,7.55,11.29H25.79L18.27,66.68Z",
  transform: "translate(-14.11 -14.11)"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M38.24,72.76V60.67a5.54,5.54,0,0,1,11.07,0v.83H47.58v-.8A3.81,3.81,0,0,0,43.77,57,3.77,3.77,0,0,0,40,60.7v12a3.77,3.77,0,0,0,3.8,3.71,3.81,3.81,0,0,0,3.81-3.71V72h1.73v.77a5.3,5.3,0,0,1-5.54,5.35A5.32,5.32,0,0,1,38.24,72.76Z",
  transform: "translate(-14.11 -14.11)"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M114.74,32.75h-2.43l-3.14-4.36h0v4.36h-1.92V23.5h1.92v4.07h0l3-4.07h2.24l-3.53,4.39Z",
  transform: "translate(-14.11 -14.11)"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M121.09,28.55V31a6.68,6.68,0,0,0,.19,1.8h-1.64a3.5,3.5,0,0,1-.09-.88h0a2.47,2.47,0,0,1-2.14,1,2,2,0,0,1-2.25-2c0-1.08.65-1.81,2.56-2.11.49-.08,1.23-.15,1.65-.18v-.23c0-.84-.44-1.17-1.08-1.17a1,1,0,0,0-1.09,1H115.4c.06-1.26,1-2.28,2.86-2.28S121.09,26.83,121.09,28.55Zm-1.75,1.17c-.39,0-.94.08-1.33.15-.75.13-1.06.37-1.06.91s.33.83,1,.83a1.49,1.49,0,0,0,1-.38,1.57,1.57,0,0,0,.38-1.26Z",
  transform: "translate(-14.11 -14.11)"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M126.89,26.12V27.7a3.05,3.05,0,0,0-.57-.07c-1.12,0-1.72.7-1.72,2v3.12h-1.82v-6.6h1.68v.94h0a2,2,0,0,1,1.8-1A2.4,2.4,0,0,1,126.89,26.12Z",
  transform: "translate(-14.11 -14.11)"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M127.88,25.06V23.5h1.82v1.56Zm0,7.69v-6.6h1.82v6.6Z",
  transform: "translate(-14.11 -14.11)"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M135.63,30.75h1.86A3,3,0,0,1,134.33,33c-2.08,0-3.29-1.45-3.29-3.56a3.2,3.2,0,0,1,3.27-3.46,3.05,3.05,0,0,1,3.06,2.2,5.53,5.53,0,0,1,.21,1.69h-4.75c0,1.36.72,1.84,1.5,1.84A1.2,1.2,0,0,0,135.63,30.75Zm-2.76-2.07h2.89a1.44,1.44,0,0,0-1.45-1.45C133.57,27.23,133,27.68,132.87,28.68Zm.33-3.28,1-1.9h2.25l-1.82,1.9Z",
  transform: "translate(-14.11 -14.11)"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M143,26.12V27.7a3,3,0,0,0-.57-.07c-1.12,0-1.71.7-1.71,2v3.12h-1.82v-6.6h1.67v.94h0a2,2,0,0,1,1.81-1A2.38,2.38,0,0,1,143,26.12Z",
  transform: "translate(-14.11 -14.11)"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M150.11,28.7v4.05h-1.82V28.88c0-1-.44-1.46-1.16-1.46s-1.3.6-1.3,1.8v3.53H144v-6.6h1.7V27h0a2.36,2.36,0,0,1,1.94-1C149.16,26,150.11,26.9,150.11,28.7Z",
  transform: "translate(-14.11 -14.11)"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M151.62,25.4l1-1.9h2.25l-1.82,1.9Zm.19,7.35v-6.6h1.82v6.6Z",
  transform: "translate(-14.11 -14.11)"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M113.07,43.61h-1.9a1.22,1.22,0,0,0-1.23-1.26c-.88,0-1.42.8-1.42,2.1s.54,2.11,1.42,2.11c.7,0,1.17-.54,1.22-1.39h1.91A2.94,2.94,0,0,1,110,48a3.22,3.22,0,0,1-3.33-3.51A3.22,3.22,0,0,1,110,40.94,2.92,2.92,0,0,1,113.07,43.61Z",
  transform: "translate(-14.11 -14.11)"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M118.52,45.75h1.86A3,3,0,0,1,117.22,48c-2.08,0-3.29-1.45-3.29-3.56a3.2,3.2,0,0,1,3.28-3.46,3,3,0,0,1,3.05,2.2,5.53,5.53,0,0,1,.21,1.69h-4.75c.06,1.36.72,1.84,1.5,1.84A1.2,1.2,0,0,0,118.52,45.75Zm-2.76-2.07h2.89a1.43,1.43,0,0,0-1.44-1.45C116.47,42.23,115.91,42.68,115.76,43.68Z",
  transform: "translate(-14.11 -14.11)"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M127.91,43.7v4h-1.82V43.88c0-1-.45-1.46-1.16-1.46s-1.3.6-1.3,1.8v3.53h-1.82v-6.6h1.7V42h0a2.36,2.36,0,0,1,1.93-1C127,41,127.91,41.9,127.91,43.7Z",
  transform: "translate(-14.11 -14.11)"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M133,46.32v1.39a3.59,3.59,0,0,1-1,.13c-1.52,0-2.19-.61-2.19-2.14V42.5h-1.06V41.15h1.06V39.43h1.82v1.72H133V42.5h-1.27v2.88c0,.72.24,1,.86,1A1.61,1.61,0,0,0,133,46.32Z",
  transform: "translate(-14.11 -14.11)"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M138.36,41.12V42.7a3.05,3.05,0,0,0-.57-.07c-1.12,0-1.72.7-1.72,2v3.12h-1.82v-6.6h1.68v.94h0a2,2,0,0,1,1.81-1A2.46,2.46,0,0,1,138.36,41.12Z",
  transform: "translate(-14.11 -14.11)"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M139.28,45.21V41.15h1.82V45c0,1,.44,1.46,1.16,1.46s1.3-.6,1.3-1.79V41.15h1.82v6.6h-1.71v-.83h0a2.34,2.34,0,0,1-1.94,1C140.23,47.91,139.28,47,139.28,45.21Z",
  transform: "translate(-14.11 -14.11)"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M157.1,43.7v4h-1.82V43.88c0-1-.4-1.46-1-1.46s-1.21.69-1.21,1.94v3.39h-1.82v-4c0-.84-.36-1.34-1-1.34s-1.2.71-1.2,1.94v3.39h-1.82v-6.6h1.71v.75h0a2.14,2.14,0,0,1,1.83-.91,2,2,0,0,1,2,1.13A2.38,2.38,0,0,1,154.79,41C156.21,41,157.1,41.9,157.1,43.7Z",
  transform: "translate(-14.11 -14.11)"
});

var _ref34 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 164.23,
  x2: 164.23,
  y2: 70.23
});

function SvgJobcheckinLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    "data-name": "Vrstva 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 343.83 70.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobcheckinLogo);
export default __webpack_public_path__ + "static/media/jobcheckin-logo.1efd3435.svg";
export { ForwardRef as ReactComponent };